if (!customElements.get('ws-offer-countdown')) {
  customElements.define('ws-offer-countdown', class extends HTMLElement {
    connectedCallback() {
      clearInterval(this.interval);
      const value = (this.dataset.endDate || '').trim();
      // Require an explicit timezone so every visitor shares the same deadline.
      const format = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2})?(?:Z|[+-]\d{2}:\d{2})$/;
      const deadline = format.test(value) ? Date.parse(value) : NaN;
      const hours = this.querySelector('[data-hours]');
      const minutes = this.querySelector('[data-minutes]');
      const seconds = this.querySelector('[data-seconds]');
      if (!Number.isFinite(deadline) || !hours || !minutes || !seconds) {
        this.hidden = true;
        return;
      }
      const update = () => {
        const remaining = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
        hours.textContent = String(Math.floor(remaining / 3600)).padStart(2, '0');
        minutes.textContent = String(Math.floor(remaining / 60) % 60).padStart(2, '0');
        seconds.textContent = String(remaining % 60).padStart(2, '0');
        if (remaining === 0) clearInterval(this.interval);
        return remaining;
      };
      this.hidden = false;
      if (update() > 0) this.interval = setInterval(update, 1000);
    }
    disconnectedCallback() {
      clearInterval(this.interval);
    }
  });
}
